import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../../images/logo_dashbo_purple.svg';
import { LocalStorage } from '../../../utils/LocalStorage';
import { FaIcon } from '../../FaIcon';
import { McpUpgradeHero } from './McpUpgradeHero';
import { McpUpgradePricingSection } from './McpUpgradePricingSection';

export function McpUpgradePage() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleLogout = () => {
        LocalStorage.removeUserData();
        navigate('/login');
    };

    return (
        <div className="upgrade-to-dashbo-wrapper">
            <header className="upgrade-topbar">
                <img src={logo} className="upgrade-topbar-logo" alt="Dashbo" />
                <button type="button" className="btn -negative upgrade-topbar-logout" onClick={handleLogout}>
                    <FaIcon iconName="power-off" />
                    <span>{t('layout.logout')}</span>
                </button>
            </header>
            <div className="upgrade-to-dashbo-page mcp-upgrade-page">
                <McpUpgradeHero />
                <McpUpgradePricingSection />
            </div>
        </div>
    );
}
